import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useOrgStore } from '../../store/org';
import { orgRoleLabel } from '../../auth/capabilities';
import { VpState } from '../../components/VelopulseShell';
import useLoad from '../../utils/useLoad';
import { vpApi, errorMessage } from '../../api/velopulse';

export default function OrgAdminSettingsPage() {
  const currentOrg = useOrgStore((s) => s.currentOrg);
  const updateCurrentOrg = useOrgStore((s) => s.updateCurrentOrg);
  const { data, error, loading, reload } = useLoad(() => vpApi.getOrgProfile(), []);
  const [form, setForm] = useState({ name: '', short_name: '', code: '', industry: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!data) return;
    setForm({
      name: data.name || '',
      short_name: data.short_name || '',
      code: data.code || '',
      industry: data.industry || '',
    });
  }, [data]);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) { toast.error('請輸入公司名稱'); return; }
    const ok = window.confirm(`確定更新「${currentOrg?.name || '目前公司'}」的公司資料？\n\n只會改這家公司的名稱與基本欄位，不會改帳務或平台設定。`);
    if (!ok) return;
    setSaving(true);
    try {
      const updated = await vpApi.updateOrgProfile({
        name: form.name.trim(),
        short_name: form.short_name.trim(),
        code: form.code.trim(),
        industry: form.industry.trim(),
      });
      updateCurrentOrg({
        name: updated.name,
        short_name: updated.short_name,
        code: updated.code,
        industry: updated.industry,
        role: updated.role,
        org_role: updated.org_role,
      });
      toast.success('公司資料已更新');
      reload();
    } catch (err) {
      toast.error(errorMessage(err, '無法儲存公司資料'));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="vp-content"><VpState loading /></div>;

  return (
    <div className="vp-content" style={{ maxWidth: 720 }}>
      <div className="vp-hello">
        <div>
          <h1>公司設定</h1>
          <p>這些設定只套用在「{currentOrg?.name || '目前公司'}」，不會改到其他公司或平台。</p>
        </div>
      </div>
      {error ? (
        <div className="vp-card"><VpState text={errorMessage(error, '無法載入公司資料。')} action={{ label: '重新載入', onClick: reload }} /></div>
      ) : (
        <form className="vp-card" onSubmit={handleSave}>
          <h2>公司資訊</h2>
          <label className="vp-label">公司名稱 *
            <input className="vp-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required maxLength={200} />
          </label>
          <label className="vp-label">簡稱
            <input className="vp-input" value={form.short_name} onChange={(e) => setForm({ ...form, short_name: e.target.value })} maxLength={80} />
          </label>
          <label className="vp-label">代碼
            <input className="vp-input" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} maxLength={40} />
          </label>
          <label className="vp-label">產業
            <input className="vp-input" value={form.industry} onChange={(e) => setForm({ ...form, industry: e.target.value })} maxLength={80} />
          </label>
          <div className="vp-kv" style={{ marginTop: 16 }}>
            <div className="k">你的身分</div>
            <div className="v">{orgRoleLabel(data || currentOrg)}</div>
          </div>
          <div className="vp-wiz-actions">
            <button type="button" className="vp-btn" onClick={() => reload()}>重設</button>
            <button type="submit" className="vp-btn primary" disabled={saving}>{saving ? '儲存中…' : '確認儲存'}</button>
          </div>
        </form>
      )}
      <div className="vp-card" style={{ marginTop: 12 }}>
        <h2>已開通模組</h2>
        <div className="vp-module-badges">
          {(data?.module_labels || []).length
            ? data.module_labels.map((m) => <span key={m.key} className="vp-badge blue">{m.label}</span>)
            : <span className="vp-muted">尚未載入</span>}
        </div>
        <p className="vp-muted" style={{ margin: '10px 0 0' }}>公司管理員只能查看。要新增或關閉模組，請洽平台管理員。</p>
      </div>
      <div className="vp-card" style={{ marginTop: 12 }}>
        <h2>尚未開放</h2>
        <p className="vp-muted" style={{ margin: 0 }}>帳務與所有人移交將於後續版本提供。此頁不會出現計費欄位。</p>
      </div>
    </div>
  );
}
